
function toggleFilter() {
    // Call the existing globofilter toggle function
    globofilter.toggleCanvas();

    // Toggle a class on the body
    document.body.classList.toggle('filter-open');
}


//announcement bar 
const announcementSlider = document.querySelector('.announcement_bar_new_main.swiper');

  if (announcementSlider) {
    new Swiper('.announcement_bar_new_main.swiper', {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      speed: 1000,
      slidesPerView: 3,
      slidesPerGroup: 1,
      allowTouchMove: false, // equivalent to `draggable: false`
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        989: {
          slidesPerView: 2,
        },
        1441: {
          slidesPerView: 3,
        }
      },
    });
  }


//Index-1

const index_1_swiper = document.querySelector('.index-1-swiper');
if (index_1_swiper) {
  new Swiper(index_1_swiper, {
    direction: 'horizontal',
    speed: 1000,
    loop: true,
    pagination: {
      el: ".snp-pagination",
      clickable: true,
      renderBullet: (index, className) => `<span class="${className}">${index + 1}</span>`
    }
  });
}


const allBanner = document.querySelectorAll('.index-1-wrapper .index-1-main');

if (allBanner.length) {
  allBanner.forEach((banner) => {
    const scrollDownBtn = banner.querySelector('.slide-to-arrow');
    if (scrollDownBtn) {
      scrollDownBtn.addEventListener('click', () => {
        const elementRect = banner.getBoundingClientRect();
        const elementTop = elementRect.top + window.pageYOffset;
        window.scrollTo({
          top: elementTop + elementRect.height,
          behavior: 'smooth'
        });
      });
    }
  });
}



//shop by brand

const brandSwiperContainer = document.querySelector('.brand-swiper');

if (brandSwiperContainer) {
  new Swiper(brandSwiperContainer, {
    direction: 'horizontal',
    slidesPerView: 4,
    spaceBetween: 24,
    loop: true,

    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },

    navigation: {
      nextEl: '.button-next',
      prevEl: '.button-prev',
    },

    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      480: {
        slidesPerView: 2,
      },
      991: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
    },

    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  });
}


//latest collection

 document.querySelectorAll('.lat-swiper').forEach(function(swiperEl) {
  const id = swiperEl.getAttribute('data-id');

  const swiperInstance = new Swiper(swiperEl, {
    direction: 'horizontal',
    slidesPerView: 5,
    spaceBetween: 24,
    loop: true,

    navigation: {
      nextEl: `.lat-next[data-id="${id}"]`,
      prevEl: `.lat-prev[data-id="${id}"]`,
    },

    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      480: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      991: {
        slidesPerView: 4,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 24,
      },
    },
  });
});
//latest shop by brand new collection 
 document.querySelectorAll('.lat-swiper-two').forEach(function(swiperEl) {
  const id = swiperEl.getAttribute('data-id');

  const swiperInstance = new Swiper(swiperEl, {
    direction: 'horizontal',
    slidesPerView: 5,
    spaceBetween: 24,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },
    navigation: {
      nextEl: `.lat-next[data-id="${id}"]`,
      prevEl: `.lat-prev[data-id="${id}"]`,
    },

    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      480: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      991: {
        slidesPerView: 4,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 24,
      },
    },
  });
});
//range collection

const rangeSwiper = document.querySelector('.range-swiper');

  if (rangeSwiper) {
    new Swiper(rangeSwiper, {
      direction: 'horizontal',
      slidesPerView: 5,
      spaceBetween: 24,
      loop: false,

      navigation: {
        nextEl: '.range-next',
        prevEl: '.range-prev',
      },

      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        480: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        991: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 24,
        },
      },
    });
  }



  const popularSwiper = document.querySelector('.popular_products_swiper');

  if (popularSwiper) {
    new Swiper(popularSwiper, {
      direction: 'horizontal',
      slidesPerView: 5,
      spaceBetween: 24,
      loop: true,

      pagination: {
        el: '.swiper-pag',
        type: 'progressbar',
      },

      navigation: {
        nextEl: '.pp-next',
        prevEl: '.pp-prev',
      },

      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        480: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        991: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 24,
        },
      },
    });
  }



// diffuser
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.diffuser-swiper').forEach(function (swiperContainer) {
    const sectionId = swiperContainer.getAttribute('data-id');

    new Swiper(swiperContainer, {
      direction: 'horizontal',
      slidesPerView: 4,
      spaceBetween: 24,
      loop: true,

      pagination: {
        el: '#swiper-pagination-' + sectionId,
        type: 'progressbar',
      },

      navigation: {
        nextEl: '#btnnext-' + sectionId,
        prevEl: '#btnprev-' + sectionId,
      },

      breakpoints: {
        0: { slidesPerView: 1 },
        480: { slidesPerView: 2 },
        991: { slidesPerView: 3 },
        1024: { slidesPerView: 4 },
      },

      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
  });
});

// your fav//
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.fav-swiper').forEach(function (swiperContainer) {
    const sectionId = swiperContainer.getAttribute('data-id');

    new Swiper(swiperContainer, {
      direction: 'horizontal',
      slidesPerView: 4,
      spaceBetween: 24,
      loop: true,

      pagination: {
        el: '#swiper-pagination-' + sectionId,
        type: 'progressbar',
      },

      navigation: {
        nextEl: '#btnnext-' + sectionId,
        prevEl: '#btnprev-' + sectionId,
      },

      breakpoints: {
        0: { slidesPerView: 1 },
        480: { slidesPerView: 2 },
        991: { slidesPerView: 3 },
        1024: { slidesPerView: 4 },
      },

      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
  });
});




  // document.addEventListener("DOMContentLoaded", function () {
  //   const reviewCount = 142; 
  //   document.getElementById("review-count").textContent = `${reviewCount}+`;
  // });


